module.exports = __webpack_public_path__ + "static/img/teambannera.a56e3ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teambannera.jpg
// module id = A69S
// module chunks = 1